import React, { Component } from 'react';

import TrennLogo from '../components/Logos/SPORTKINDER BERLIN, Boxen.jpg';
import SportKinderBerlinLogo from '../components/Logos/Sport Kinder Berlin - Logo Slogan gr.jpg';
import AllianzLogo from '../components/Logos/Logo_Allianz_Kinder_Stiftungszeile_4c.jpg';
import AllianzLogo2 from '../components/Logos/kihifo-logo-4-300x151.png';
import Kooperationspartner from './Kooperationspartner/Kooperationspartner';
import BezirksamtSpandauLogo from '../components/Logos/2017_Logo_QPK_JA_quer.jpg';
import InFormLogo from '../components/Logos/LOGO-WIR-SIND-IN-FORM.jpg';
import BezirksamtSteglitzLogo from '../components/Logos/Bild1.jpg';
import { FaMapMarkedAlt, FaPhone, FaEnvelope, FaGlobeEurope } from 'react-icons/fa';
import { connect } from 'react-redux';

class Home extends Component {
    state = {

    };

    render() {
        let trennLogo = (
            <div>
                <img
                    alt=""
                    src={TrennLogo}
                    width="750"
                    height="40"
                    style={{ display: "block", marginLeft: "auto", marginRight: "auto", opacity: 0.4 }}
                />
            </div>
        );

        let sportKinderBerlinLogo = (
            <div>
                <img
                    alt=""
                    src={SportKinderBerlinLogo}
                    width="200"
                    height="120"
                />
            </div>
        );

        let informLogo = (
            <div>
                <img
                    alt=""
                    src={InFormLogo}
                    width="200"
                    height="120"
                />
            </div>
        );

        let sportKinderBerlin = (
            <div className="row">
                <div className="column">
                    {sportKinderBerlinLogo}
                </div>
                <div className="column">
                    {informLogo}
                </div>
            </div>

        );

        let kooperationspartner = (
            <div style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}>
                <div className="row" style={{ textAlign: "center", display: "block ruby" }}>
                    <div className="column">
                        <Kooperationspartner
                            src={AllianzLogo2}
                            cardWidth='20rem'
                            pictureWidth="250"
                            pictureHeight="120"
                            title="Allianz Berlin / Leipzig"
                        />
                    </div>
                    <div className="column">
                        <Kooperationspartner
                            src={AllianzLogo}
                            cardWidth='20rem'
                            pictureWidth="250"
                            pictureHeight="120"
                            title="Allianz M�nchen"
                        />
                    </div>
                </div>
                <br />
                <Kooperationspartner
                    src={BezirksamtSpandauLogo}
                    cardWidth='40rem'
                    pictureHeight="90"
                    title="Bezirksamt Spandau"
                />
                <br />
                <Kooperationspartner
                    src={BezirksamtSteglitzLogo}
                    pictureWidth="150"
                    pictureHeight="150"
                    cardWidth='40rem'
                    title="Bezirksamt Steglitz-Zehlendorf"
                />
            </div>
        );


        return (
            <div>
                <h1>Willkommen bei motorik-test.de</h1>
                <p>
                    Dieses Portal dient der professionellen Dokumentation sportmotorischer Untersuchungen. Unser Ziel ist es, den Aufwand für Sie so gering wie möglich zu halten, damit Sie sich voll auf die Förderung der Kinder konzentrieren können.
                    Mit dieser Datenbank unterstützen wir Sie dabei, die motorische Entwicklung von Kindern in der Kita strukturiert zu erfassen und individuelle Potenziale frühzeitig zu erkennen.
                </p>
                <p>
                    Erste Schritte:
                    Unter dem Menüpunkt "Benutzer" und "Anleitung“ finden Sie eine detaillierte Anleitung zur Handhabung dieser Website sowie zur korrekten Dateneingabe.
                    
                    Vielen Dank, dass Sie mit Ihrer Arbeit zur wissenschaftlichen Basis unserer Datenbank beitragen und somit eine bestmögliche Förderung der Kinder ermöglichen.
                </p>
                <br />
                <ul style={{ display: "inline-block", padding: "5px" }} >
                    <li><b>Kontakt für Kitas:</b></li>
                    <li><br/></li>
                    <li>Alicia Schwarz</li>
                    <li>SPORTKINDER BERLIN e.V.</li>
                    <li>Fachbereichsleitung Kita & Bewegungscoach Falkenhagener Feld </li>
                    <li>B.A. Sport und angewandte Trainingswissenschaften</li>
                    <li>M.A. Sportwissenschaften</li>
                    <li>Zweigstelle Spandau: Geschäfts- & Beratungsstelle</li>
                    <li><div style={{ display: 'flex', alignItems: 'center' }}><FaMapMarkedAlt style={{ margin: '5px', marginRight: '15px' }} size={36} /><span>Sprengelstraße 17 | 13595 Berlinn</span></div></li>
                    <li><div style={{ display: 'flex', alignItems: 'center' }}><FaPhone style={{ margin: '5px', marginRight: '15px' }} size={36} /><span>01573 9600644</span></div></li>
                    <li><div style={{ display: 'flex', alignItems: 'center' }}><FaEnvelope style={{ margin: '5px', marginRight: '15px' }} size={36} /><span>kita@sportkinder-berlin.de</span></div></li>
                    <li><div style={{ display: 'flex', alignItems: 'center' }}><FaGlobeEurope style={{ margin: '5px', marginRight: '15px' }} size={36} /><span>www.sportkinder-berlin.de</span></div></li>
                </ul>
                <ul style={{ display: "inline-block" , padding: "5px"}}>
                    <li><b>Kontakt für weitere Fragen und Anliegen:</b></li>
                    <li><br/></li>
                    <li>Benjamin Jeremias</li>
                    <li>SPORTKINDER BERLIN e.V.</li>
                    <li>Sportfachlicher Leiter SpoKi und Leitender Bewegungscoach Spandau</li>
                    <li>B.A. Sport und angewandte Trainingswissenschaften</li>
                    <li><br /></li>
                    <li>Zweigstelle Spandau: Geschäfts- & Beratungsstelle</li>
                    <li><div style={{ display: 'flex', alignItems: 'center' }}><FaMapMarkedAlt style={{ margin: '5px', marginRight: '15px' }} size={36} /><span>Sprengelstraße 17 | 13595 Berlinn</span></div></li>
                    <li><div style={{ display: 'flex', alignItems: 'center' }}><FaPhone style={{ margin: '5px', marginRight: '15px' }} size={36} /><span>(030) 443 5176 4</span></div></li>
                    <li><div style={{ display: 'flex', alignItems: 'center' }}><FaEnvelope style={{ margin: '5px', marginRight: '15px' }} size={36} /><span>spandau@sportkinder-berlin.de</span></div></li>
                    <li><div style={{ display: 'flex', alignItems: 'center' }}><FaGlobeEurope style={{ margin: '5px', marginRight: '15px' }} size={36} /><span>www.sportkinder-berlin.de</span></div></li>
                </ul>
                <br />
                {sportKinderBerlin}
                <br />
                <hr
                    style={{
                        color: "gray",
                        backgroundColor: "gray",
                        height: 1
                    }}
                />
                {trennLogo}
                <h5
                    style={{ textAlign: "center" }}>In Kooperation mit</h5>
                <br />
                {kooperationspartner}
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        token: state.token,
        username: state.username
    };
};

export default connect(mapStateToProps)(Home);